// extracted by mini-css-extract-plugin
export default {"wrapper":"WE","content":"XE","firstSection":"YE","text":"ZE","table":"aF","tableText":"bF","row":"cF","column_2":"eF","column_1":"fF","column_3":"gF"};
    if(module.hot) {
      // 1714422956258
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  